import {buildAssetDisplayCode} from '@sollapay/domain/asset-types';
import {AssetType} from '@sollapay/enums';

import type {AssetSummaryDTO, TrustAccountActivityDTO} from '@sollapay/types';

export function castMetadata<T>(activity: TrustAccountActivityDTO): T | null {
  return activity.metadata as T | null;
}

interface LegacyUnitMetadata {
  id: string;
  buildingNumber: string;
  unitNumber: string;
}

/** Also parses the legacy `" & "`-joined `buyerName` string — use `buyerCount`, not this array's length, for an authoritative total. */
export function readBuyerNames(
  meta: {buyerNames?: string[] | null; buyerName?: string | null} | null | undefined
): string[] {
  if (!meta) return [];
  if (Array.isArray(meta.buyerNames) && meta.buyerNames.length > 0) return meta.buyerNames;
  if (typeof meta.buyerName === 'string' && meta.buyerName.length > 0) {
    return meta.buyerName
      .split(' & ')
      .map(name => name.trim())
      .filter(Boolean);
  }
  return [];
}

/** Pre-redesign rows persisted `unit: {id, buildingNumber, unitNumber}` instead of `asset` — synthesize one so old rows keep their subtitle and deep link. */
export function readAssetSummary(activity: TrustAccountActivityDTO): AssetSummaryDTO | null {
  const metadata = activity.metadata as {asset?: AssetSummaryDTO; unit?: LegacyUnitMetadata} | null;
  if (metadata?.asset) return metadata.asset;

  const unit = metadata?.unit;
  if (!unit) return null;

  const {id, buildingNumber, unitNumber} = unit;
  return {
    id,
    assetType: AssetType.DEVELOPER_UNIT,
    displayCode: buildAssetDisplayCode(AssetType.DEVELOPER_UNIT, {buildingNumber, unitNumber}),
    buildingNumber,
    unitNumber,
    address: null,
    floor: null,
    block: null,
    parcel: null,
    subParcel: null,
    area: null,
    referencePriceNis: null,
    description: null
  };
}
